import { render, staticRenderFns } from "./TriviaController.vue?vue&type=template&id=cdade73c&"
import script from "./TriviaController.vue?vue&type=script&lang=js&"
export * from "./TriviaController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports